<div class="custom-modal-wrapper" [ngStyle]="{'z-index': modal.id + 600}" 
        *ngFor="let modal of modalService.modals | async as modals; index as i;">
    <ng-container *ngTemplateOutlet="modal.template; context: modal.context"></ng-container>
</div>